import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UserSessionService } from '../shared/services/user.service';
import { Adherent } from '../shared/interfaces/BDD-Ref/adherent';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { filter, Subject, takeUntil, tap } from 'rxjs';
import { OfficineSelectorComponent } from '../shared/components/officine-selector/officine-selector.component';
import { GestionComptesService } from '../shared/services/gestion-comptes.service';
import { MatTabChangeEvent, MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatSelectChange } from '@angular/material/select';
import { UtilisateursComponent } from './utilisateurs/utilisateurs.component';
import { DemandesComponent } from './demandes/demandes.component';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { FilialeSelectorComponent } from '../shared/components/filiale-selector/filiale-selector.component';

@Component({
  selector: 'app-gestion-comptes',
  templateUrl: './gestion-comptes.component.html',
  styleUrl: './gestion-comptes.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MatToolbar,
    ReactiveFormsModule,
    MatTableModule,
    MatTabsModule,
    MatTabGroup,
    MatTab,
    UtilisateursComponent,
    DemandesComponent,
    OfficineSelectorComponent,
    FilialeSelectorComponent,
  ],
})
export class GestionComptesComponent implements OnInit, OnDestroy {
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  adherents: Adherent[] = [];
  selectedAdherent: Adherent | null = null;
  formSelect: FormGroup;
  firstname: any;
  lastname: any;
  email: any;
  activeTab!: number;
  idAdherent!: number;
  idUser!: string;
  user: any;
  enseignes: any[] = [];
  selectedFiliale: string | null = null;
  activiteAdherent: string = '';
  private _destroying$: Subject<void> = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserSessionService,
    private gestionComptesService: GestionComptesService,
  ) {
    // Initialisez le formulaire avec une propriété 'selectedOfficine'
    this.formSelect = this.formBuilder.group({
      selectedOfficine: null,
    });
    const activeTabIndex = localStorage.getItem('activeTabIndex');

    if (activeTabIndex !== null) {
      // Set the active tab based on the retrieved index.
      this.activeTab = +activeTabIndex;
    } else {
      this.activeTab = 0;
    }
  }

  ngOnInit(): void {
    this.onTabSelected(3);
    this.userService.activite$
      .pipe(
        takeUntil(this._destroying$),
        filter((v) => v !== null),
      )
      .subscribe((activite) => {
        this.activiteAdherent = activite;
      });

    this.userService
      .getSelectedAdherent()
      .pipe(
        takeUntil(this._destroying$),
        tap((adherent) => {
          this.selectedAdherent = adherent;
        }),
      )
      .subscribe();

    this.userService.filiale$
      .pipe(takeUntil(this._destroying$))
      .subscribe((filiale) => {
        this.selectedFiliale = filiale;
      });

    const currentUser = localStorage.getItem('currentUserAdmin');
    this.user = currentUser
      ? JSON.parse(currentUser)
      : {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
        };
    this.idUser = this.user.id;

    // Appel du service pour récupérer les enseignes du titulaire
    if (this.user && this.user.email) {
      this.gestionComptesService
        .getEnseignesByTitulaire(this.user.email)
        .subscribe((enseignes) => {
          // Tu peux stocker les enseignes dans une propriété si besoin
          this.enseignes = enseignes;
        });
    }
  }

  ngAfterViewInit() {
    // Retrieve the index of the active tab from local storage.
    const activeTabIndex = localStorage.getItem('activeTabIndex');

    if (activeTabIndex !== null) {
      // Set the active tab based on the retrieved index.
      this.activeTab = +activeTabIndex;
    }
    // Select the correct tab in the user interface after the tabs have been initialized.
    this.tabGroup.selectedIndex = this.activeTab;
  }

  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  /**
   * Evenement pour mettre à jour les données de l'officine en fonction de l'adhérent
   * @param {MatSelectChange} event - L'adhérent.
   * @returns {void}
   */
  onStatusOfficineSelectionChange(event: MatSelectChange): void {
    const adherent: Adherent = event.value;
    this.userService.setSelectedAdherent(adherent);
    this.idAdherent = adherent.idAdherent;
  }

  /**
   * Met à jour les données de l'adhérent
   * @param {Adherent} adherent - L'adhérent.
   * @returns {void}
   */
  setAdherent(adherent: Adherent): void {
    this.formSelect.get('selectedOfficine')?.setValue(adherent);
    this.idAdherent = adherent.idAdherent;
    this.selectedAdherent = adherent;
  }

  /**
   * Handles tab change event.
   * @param {MatTabChangeEvent} event - The event object representing the tab change.
   */
  public tabChanged(event: MatTabChangeEvent): void {
    this.activeTab = event.index;

    // Save the active tab index in local storage
    localStorage.setItem('activeTabIndex', this.activeTab.toString());
  }
  /**
   * Highlights the selected tab and sets the others to the default state
   * @param {number} index - The index of the selected tab
   */
  onTabSelected(index: number): void {
    const menuElements = document.querySelectorAll('.menu-element');
    if (menuElements.length > 3 && index >= 0 && index < menuElements.length) {
      for (let i = 0; i < menuElements.length; i++) {
        const menuElement = menuElements[i] as HTMLElement;
        if (i === index) {
          menuElement.classList.remove('menu-element--default');
          menuElement.classList.add('menu-element--highlighted');
        } else {
          menuElement.classList.remove('menu-element--highlighted');
          menuElement.classList.add('menu-element--default');
        }
      }
    }
  }
}
